module.exports = __webpack_public_path__ + "static/img/tools_bg04.c686148f.png";